export default __webpack_public_path__ + "static/media/techblog.a88d0570.png";